import {LoDashStatic} from "lodash";

const _ = <LoDashStatic> require('lodash');
require('./wmsFifoDialog.less');

interface InventoryItem {
    companyId: number,
    itemId: string,
    itemName: string,
    locationId: string,
    locationName: string,
    qtyReservedErp: number,
    quantity: number,
    updatedTime: string,
    warehouseId: number,
    zoneId: string
}


class WmsFifoDialogController {
    item: InventoryItem;
    fifo;
    originalFifoList;
    newItem: { date?: Date, quantity?: number } = {};
    lineQuantity: number = 0;
    saveEnabled: boolean;

    constructor(private toastService, private $mdDialog, private WmsFifo, private $filter) {
    }

    $onInit() {
        this.WmsFifo.getFifo({itemId: this.item.itemId, locationId: this.item.locationId}).$promise.then((results) => {
            this.fifo = results.content.map(x => {
                x.date = new Date(x.date);
                this.lineQuantity += x.quantity;
                return x;
            });
            this.originalFifoList = results.content;
            this.isSaveEnabled();
        }, (error) => {
            this.toastService.parseError(error);
        });
    }


    isSaveEnabled() {
        this.lineQuantity = _.sumBy(this.fifo, 'quantity');
        this.saveEnabled = this.lineQuantity === this.item.quantity;
    }

    addNew() {
        if (!_.some(this.fifo, (fifoItem: any) => {
                return this.$filter('date')(fifoItem.date, 'yyyy-MM-dd') === this.$filter('date')(this.newItem.date, 'yyyy-MM-dd');
            })) {
            this.fifo.push(this.newItem);
            this.newItem = {};
            this.isSaveEnabled();
            this.fifo = _.orderBy(this.fifo, ['date'], ['asc'])
        } else {
            this.toastService.showSimpleToast("Dato allerede valgt, vennligst endre antall", 3000);
        }
    }

    saveNew(date, qty) {
        const parsedDate = this.$filter('date')(date, 'yyyy-MM-dd');
        return this.WmsFifo.postFifo(
            {itemId: this.item.itemId, locationId: this.item.locationId},
            {qty: qty, date: parsedDate}
        ).$promise;
    }

    deleteItem(index) {
        this.fifo.splice(index, 1);
        this.isSaveEnabled();
    }

    deleteFifo(item) {
        return this.WmsFifo.deleteFifo(
            {id: item.id}
        ).$promise;
    }

    save() {
        Promise.all( _.forEach(this.originalFifoList, (originalFifoItem) => {
            return this.deleteFifo(originalFifoItem);
        })).then(() => {
            Promise.all(_.forEach(this.fifo, (fifoItem) => {
                return this.saveNew(fifoItem.date, fifoItem.quantity);
            })).then(() => {
                this.hide();
            }, () => {
                // TODO Handle errors properly or give feedback
            });
        }, () => {
            // TODO Handle errors properly or give feedback
        });
    }

    hide() {
        this.$mdDialog.hide();
    };

    cancel() {
        this.$mdDialog.cancel();
    };
}

class WmsFifoDialogOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcWmsFifoDialogController";
    public template: any = require('./wmsFifoDialog.html');
    bindings: any = {
        item: '=',
    };
}

rkcApp.controller("rkcWmsFifoDialogController",
    ['toastService', '$mdDialog', 'WmsFifo', '$filter',
        function (toastService, $mdDialog, WmsFifo, $filter) {
            return new WmsFifoDialogController(toastService, $mdDialog, WmsFifo, $filter);
        }])
    .component("wmsFifoDialog", new WmsFifoDialogOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/wms-fifo-dialog/wmsFifoDialog.ts
 **/